<template>
	<textarea
		class="form-control"
		:value="value"
		@input="emitInput"
	></textarea>
</template>

<script>
	export default {
		props: {
			value: { default: '' },
			autoResize: { default: true }
		},

		mounted() {
			if (this.autoResize) {
				this.resize();
			}
		},

		methods: {
			emitInput(e) {
				this.$emit('input', e.target.value);

				if (this.autoResize) {
					this.resize();
				}
			},

			resize() {
				if (this.$el.scrollHeight > 0) {
					this.$el.style.overflow = 'hidden';
					this.$el.style.height = 'auto';
					this.$el.style.height = (this.$el.scrollHeight) + 'px';
				}
			}
		}
	};
</script>


// WEBPACK FOOTER //
// application/components/form/textarea.vue?2dd548b2